<template>
  <div class="events-page">
    <!-- Hero Banner -->
    <section class="hero-banner">
      <div class="hero-content">
        <p class="hero-label">活动中心</p>
        <h1 class="hero-title">精彩活动 · 限时优惠</h1>
        <p class="hero-subtitle">参与线上线下活动，赢取产品折扣与免费试用</p>
      </div>
    </section>

    <!-- Main Content -->
    <div class="page-container">
      <!-- Events Grid -->
      <div class="events-grid">
        <div
          v-for="evt in events"
          :key="evt.id"
          class="event-card"
          @click="handleEventClick(evt)"
        >
          <div
            class="event-card-header"
            :style="{ background: evt.gradient }"
          >
            <Icon :icon="evt.icon" :size="48" color="rgba(255,255,255,0.4)" />
            <div class="event-tags">
              <span
                class="event-status-tag"
                :style="{ background: evt.statusColor }"
              >
                {{ evt.status }}
              </span>
              <span class="event-type-tag">{{ evt.type }}</span>
            </div>
          </div>
          <div class="event-card-body">
            <h4 class="event-title">{{ evt.title }}</h4>
            <p class="event-desc">{{ evt.desc }}</p>
            <div class="event-meta">
              <span class="event-date">📅 {{ evt.date }}</span>
              <span class="event-location">📍 {{ evt.location }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router'
import { Icon } from '@/components/Icon'
import { events, type EventItem } from '../data/portalData'

defineOptions({ name: 'EventsPage' })

const router = useRouter()

function handleEventClick(evt: EventItem) {
  router.push(`/portal/events/${evt.id}`)
}
</script>

<style lang="scss" scoped>
.events-page {
  // Hero Banner
  .hero-banner {
    height: 240px;
    background: linear-gradient(135deg, #001B5E, #0066FF);
    display: flex;
    align-items: center;
    padding: 0 24px;
  }

  .hero-content {
    max-width: 1280px;
    margin: 0 auto;
    width: 100%;
  }

  .hero-label {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
    letter-spacing: 4px;
    margin: 0 0 8px;
  }

  .hero-title {
    font-size: 36px;
    font-weight: 900;
    color: #fff;
    margin: 0 0 8px;
  }

  .hero-subtitle {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
  }

  // Page Container
  .page-container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 40px 24px;
  }

  // Events Grid
  .events-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;

    @media (max-width: 1024px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .event-card {
    background: #fff;
    border: 1px solid #E5E7EB;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
    }
  }

  .event-card-header {
    height: 160px;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .event-tags {
    position: absolute;
    top: 12px;
    left: 12px;
    display: flex;
    gap: 8px;
  }

  .event-status-tag {
    font-size: 12px;
    color: #fff;
    padding: 3px 10px;
    border-radius: 4px;
    font-weight: 600;
  }

  .event-type-tag {
    font-size: 12px;
    color: #fff;
    padding: 3px 10px;
    border-radius: 4px;
    font-weight: 600;
    background: rgba(0, 0, 0, 0.5);
  }

  .event-card-body {
    padding: 20px;
  }

  .event-title {
    font-size: 15px;
    font-weight: 600;
    margin: 0 0 8px;
    color: #111827;
    line-height: 1.4;
  }

  .event-desc {
    font-size: 13px;
    color: #6B7280;
    margin: 0 0 12px;
    line-height: 1.6;
  }

  .event-meta {
    display: flex;
    gap: 16px;
    font-size: 12px;
    color: #9CA3AF;
  }
}
</style>
